export const TableDataValue = ({ text, outlineStyle }: any) => {
  return (
    <div className="text-[14px]">
      <span className={outlineStyle}>{text}</span>
    </div>
  );
};
